<template>
  <div class="form-group text-left">
    <hl-Datepicker
      :name="name"
      :label="label"
      :placeholder="placeholder"
      :clearable="true"
      :disabledDates="disabledDates"
      :error="error"
      v-model="dateName"
    />
  </div>
</template>

<script>
import FilterMixin from '@/components/reports/filters/FilterMixin';
import Datepicker from '@modules/husleie-framework/src/components/forms/inputs/Datepicker.vue';

export default {
  name: 'DateFilterItem',

  components: {
    'hl-Datepicker': Datepicker,
  },

  props: {
    name: String,
    label: String,
    placeholder: String,
    defaultValue: String,
    disabledDates: {
      type: Object,
      default: undefined,
    },
    error: String,
  },

  mixins: [FilterMixin],

  computed: {
    dateName: {
      get() {
        return this.getLocalSubValueOrDefault(this.name, this.defaultValue);
      },
      set(v) {
        this.setLocalValue(this.name, v);
      },
    },
  },
};
</script>

<style scoped lang="scss"></style>
